// import services from '@/helpers/services.js'
// import { Message } from 'element-ui'
function getRole () {
  const role = window.localStorage.getItem('role')
  if (role) {
    return JSON.parse(role)
  } else {
    return null
  }
}
function getAccessToken () {
  const idToken = window.localStorage.getItem('idToken')
  if (idToken) {
    return JSON.parse(idToken)
  } else {
    return null
  }
}

export {
  getRole,
  getAccessToken
}
